import { format, parse } from 'date-fns';

export const convertISOToPhDate = (date: string): string =>
  format(new Date(date), 'MM/dd/yyyy');

export const convertPhToISODate = (date: string) => {
  const dateParsed = parse(date, 'MM/dd/yyyy', new Date());

  return format(dateParsed, 'yyyy-MM-dd');
};
